import produce from 'immer';

import { AUTH_TYPES, AuthState, AuthActionTypes } from './authTypes';
import { API_REQUEST_STATE } from '../../enums/apiRequestState';

const initialState: AuthState = {
  errorCode: null,
  apiMeRequestState: API_REQUEST_STATE.IDLE,
  isAuthenticated: false,
  me: {
    roles: [],
    id: 0,
    email: '',
    username: '',
  },
};

export const authReducer = produce((draft: AuthState, action: AuthActionTypes) => {
  switch (action.type) {
    case AUTH_TYPES.SET_IS_AUTHENTICATED:
      draft.isAuthenticated = action.payload.isAuthenticated;
      break;
    case AUTH_TYPES.SET_API_ME_REQUEST_STATE:
      draft.apiMeRequestState = action.payload.apiMeRequestState;
      break;
    case AUTH_TYPES.API_ERROR:
      draft.errorCode = action.payload.errorCode;
      break;
    case AUTH_TYPES.GET_ME_SUCCESS:
      draft.me = action.payload.me;
      draft.isAuthenticated = true;
      break;
    case AUTH_TYPES.GET_ME_ERROR:
      draft.me = {
        roles: [],
        id: 0,
        email: '',
        username: '',
      };
      draft.isAuthenticated = false;
      break;
  }
}, initialState);
